import React from 'react';
import './Highlights.css';

// Import your poster images
import poster1 from '../assets/posters/stolen.jpg';
import poster2 from '../assets/posters/mismatcheds3.jpg';
import poster3 from '../assets/posters/race.webp';
import poster4 from '../assets/posters/rw.jpg';

const posters = [
  { title: 'Stolen', image: poster1 },
  { title: 'Mismatched - Season 3', image: poster2 },
  { title: 'Race', image: poster3 },
  { title: 'Roaring Wishpers', image: poster4 },
];

const Highlights = () => {
  return (
    <section className="highlights-section">
      <h2 className="highlights-title">OUR FEATURED WORK</h2>
      <p className="highlights-subtitle">
        A showcase of our latest video productions — from gripping thrillers to heartfelt dramas. Explore the stories we've brought to life as a leading video production house.
      </p>
      <div className="highlights-grid">
        {posters.map((poster, index) => (
          <div className="highlight-card" key={index}>
            <img
              src={poster.image}
              alt={poster.title}
              className="highlight-image"
            />
            <div className="highlight-caption">{poster.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Highlights;
